import { PropsWithChildren } from "react"
import { useTranslation } from "react-i18next"

import { SOCIAL_ADDRESSES, SocialPlatform } from "@/constants"

const Row = ({
  children,
  label,
}: PropsWithChildren<{ label: SocialPlatform }>) => (
  <>
    <p className="pt-md text-md-regular">{label}</p>
    <a
      className="pb-md text-sm-regular-underlined text-utility-blue-dark-500"
      href={SOCIAL_ADDRESSES[label]}
      target="_blank"
      onClick={() => {
        window.gtag("event", "outbound_click", {
          destination: SOCIAL_ADDRESSES[label],
        })
      }}
      rel="noreferrer"
    >
      {children}
    </a>
  </>
)
export const FollowUs = () => {
  const { t } = useTranslation()
  return (
    <div className="p-md">
      <p className="text-lg-regular">{t("socials.followUs")}</p>
      <Row label="LinkedIn">
        linkedin.com/company/{<br />}adaptive-consulting-ltd/
      </Row>
      <Row label="Twitter">@WeAreAdaptive</Row>
      <Row label="Github">github.com/adaptiveConsulting</Row>
    </div>
  )
}
